// Auto-generated by vite-plugin-content
// Do not edit manually

import type {
  CareerEntry,
  TechItem,
  StatsData,
  EducationEntry,
  CertificationEntry,
  ProductEntry,
  CategoryMeta,
  ContentManifest
} from './content-types'

export const career: CareerEntry[] = [
  {
    "slug": "habitusnet-2022",
    "category": "career",
    "company": "Habitusnet Consulting AG",
    "role": "Head of Infrastructure & Security Consulting",
    "type": "employment",
    "location": "Zurich, Switzerland",
    "start": "2022-04",
    "end": "present",
    "icon": "habitusnet.svg",
    "tags": [
      "infrastructure",
      "security",
      "consulting",
      "m365",
      "devops",
      "ai"
    ],
    "products_built": [
      "x2bc",
      "agentisphere",
      "mcp-server",
      "career-platform",
      "osint-tool"
    ],
    "team_size": 8,
    "content": "Leading infrastructure and security consulting practice, combining deep Microsoft 365 expertise with modern AI/ML integration. Built multiple SaaS products leveraging LLMs to transform client interactions and automate complex workflows.\n\nKey focus areas include M365 tenant architecture, Dynamics 365 implementations, and developing innovative tools that leverage frontier AI models for infrastructure automation.\n\n## Highlights\n\n- 3rd level engineering and architect for many M365 tenants (MSP/Lighthouse/MS Partner)\n- Led senior engineering, management, and migration projects (M365 & Power Platform, CoPilot, Dynamics 365)\n- Software Development in React/TypeScript (X2BC, Agentisphere, MCP Server, Career Platform)\n- C-level strategic consulting on business process optimization and infrastructure planning\n- Integrated automation utilizing Infrastructure-as-Code (IaC) principles"
  },
  {
    "slug": "sygnum-2021",
    "category": "career",
    "company": "Sygnum Bank AG",
    "role": "Head of Infrastructure",
    "type": "employment",
    "location": "Zurich, Switzerland",
    "start": "2021-03",
    "end": "2022-03",
    "icon": "sygnum.svg",
    "tags": [
      "fintech",
      "crypto",
      "infrastructure",
      "itil",
      "m365",
      "compliance"
    ],
    "products_built": [],
    "team_size": 12,
    "content": "Led infrastructure operations at Switzerland's first FINMA-licensed digital asset bank. Rebuilt the IT operations team following leadership transition, implementing ITIL principles to transform reactive support into proactive infrastructure management.\n\nManaged complex multi-cloud environment spanning Azure, AWS, and on-premises systems while maintaining strict regulatory compliance in the crypto-finance sector.\n\n## Highlights\n\n- Rebuilt IT operations team in regulated crypto-finance environment\n- Operated Switzerland's first FINMA-approved crypto bank IT infrastructure\n- Transitioned infrastructure management from reactive to proactive using ITIL principles\n- Architected comprehensive roadmap integrating M365, Teams, DevOps, and IaC\n- Initiated \"Onboarding Excellence\" project improving candidate experience"
  },
  {
    "slug": "flyerbee-2016",
    "category": "career",
    "company": "FLYERBEE AG",
    "role": "CEO / Co-founder",
    "type": "co-founded",
    "location": "Zurich, Switzerland",
    "start": "2016-03",
    "end": "2021-02",
    "icon": "flyerbee.svg",
    "tags": [
      "startup",
      "adtech",
      "mobile",
      "iot",
      "leadership"
    ],
    "products_built": [
      "flyerbee-platform",
      "mobile-workforce-app"
    ],
    "team_size": 30,
    "content": "Founded and led a venture-backed startup building a hyper-local, \"anti-globalized\" advertising and logistics marketplace. Developed innovative Mobile Workforce Platform integrating ad space reservation, planning, and lifecycle management with IoT sensors.\n\nDemonstrated full-stack leadership across all business functions from engineering to compliance, successfully scaling to 15 employees before COVID impact.\n\n## Highlights\n\n- Founded and funded successful startup with 15 employees\n- Developed hyper-local ad/logistics marketplace with distributed ground force\n- Built Mobile Workforce Platform with BLE sensors and mobile analytics\n- Recruited and managed team of 30+ developers and professionals\n- Led product management for location-based ad tech innovation\n- Wore multiple hats: HR, Legal, Compliance, Marketing, Engineering, Product, Sales"
  },
  {
    "slug": "idezo-2014",
    "category": "career",
    "company": "idezo GmbH",
    "role": "Co-founder, Director",
    "type": "co-founded",
    "location": "Zurich, Switzerland",
    "start": "2014-01",
    "end": "2020-12",
    "icon": "idezo.svg",
    "tags": [
      "innovation",
      "ar-vr",
      "computer-vision",
      "emerging-tech"
    ],
    "products_built": [],
    "team_size": 8,
    "content": "Co-founded and directed an innovation lab exploring cutting-edge technologies including AR/VR, computer vision, adaptive tech, and human-machine interfaces. Created groundbreaking concepts by integrating design thinking with engineering excellence.\n\nBuilt and nurtured cross-functional teams focused on translating emerging tech into practical client solutions.\n\n## Highlights\n\n- Founded innovation lab focused on emerging technologies\n- Developed AR/VR, computer vision, and adaptive tech solutions\n- Built cross-functional team fostering creativity and results\n- Integrated design and engineering for impactful client solutions\n- Emphasized storytelling in client engagement"
  },
  {
    "slug": "nhabitus-2009",
    "category": "career",
    "company": "nHabitus GmbH",
    "role": "Director, Founder",
    "type": "founded",
    "location": "Zurich, Switzerland",
    "start": "2009-01",
    "end": "2020-12",
    "icon": "nhabitus.svg",
    "tags": [
      "hosting",
      "platform",
      "operations"
    ],
    "products_built": [
      "nhabitus-platform"
    ],
    "team_size": 6,
    "content": "Founded and directed a hosting and platform services company, focusing on reliability, security, and customer satisfaction. Drove strategic partnerships for business expansion while optimizing operations for efficiency.\n\n## Highlights\n\n- Spearheaded technical development optimizing platform performance\n- Drove strategic partnerships for rapid business expansion\n- Streamlined operations achieving cost reduction and quality improvement\n- Established high-performing team dedicated to collective goals"
  },
  {
    "slug": "habitusnet-2000",
    "category": "career",
    "company": "Habitusnet Consulting AG",
    "role": "Managing Partner",
    "type": "founded",
    "location": "Zurich, Switzerland",
    "start": "2000-01",
    "end": "2016-12",
    "icon": "habitusnet.svg",
    "tags": [
      "consulting",
      "it-services",
      "cloud",
      "leadership"
    ],
    "products_built": [],
    "team_size": 15,
    "content": "Founded and grew Habitusnet Consulting into a successful IT consulting firm serving enterprise clients across UK, Netherlands, and Switzerland. Specialized in IT operations and office technology infrastructure with strong focus on client relationships.\n\nBuilt and led team of senior technology consultants, achieving exceptional client retention and driving cloud transformation initiatives for digital business operations.\n\n## Highlights\n\n- Founded Habitusnet Consulting, focusing on IT and office design services\n- Built consulting team supporting 25+ organizations across Europe\n- Achieved 100% growth with new clients from 2007-2011\n- 40% increase in hosting revenue with successful spin-off\n- Maintained 95% client retention rate over a decade\n- Spearheaded cloud transformation initiatives"
  },
  {
    "slug": "ubs-1996",
    "category": "career",
    "company": "UBS AG / SBC Warburg / Perot Systems",
    "role": "Platform Engineer & Project Manager",
    "type": "employment",
    "location": "Zurich, Switzerland",
    "start": "1996-01",
    "end": "1999-12",
    "icon": "ubs.svg",
    "tags": [
      "banking",
      "windows",
      "consulting",
      "project-management"
    ],
    "products_built": [],
    "team_size": 0,
    "content": "Platform engineering and project management roles in global banking environment. Gained foundational experience in enterprise Windows systems, organizational consulting, and software project delivery.\n\n## Highlights\n\n- Windows Systems Platform Engineering\n- Organizational Consulting\n- Software Project Manager"
  },
  {
    "slug": "autodesk-1994",
    "category": "career",
    "company": "Autodesk Inc.",
    "role": "IT Services Manager",
    "type": "employment",
    "location": "Seattle, WA / Portland, OR",
    "start": "1994-01",
    "end": "1996-12",
    "icon": "autodesk.svg",
    "tags": [
      "it-services",
      "management"
    ],
    "products_built": [],
    "team_size": 0,
    "content": "IT Services Manager at Autodesk, managing IT operations across Seattle and Portland offices. Early career foundation in IT service delivery and team management.\n\n## Highlights\n\n- IT Services Manager for Pacific Northwest region\n- Early career IT leadership experience"
  }
] as CareerEntry[]

export const tech: TechItem[] = [
  {
    "slug": "cloud-strategy",
    "category": "cto",
    "name": "Multi-Cloud Strategy",
    "icon": "cloud.svg",
    "proficiency": "expert",
    "years": 17,
    "tags": [
      "azure",
      "aws",
      "gcp",
      "architecture"
    ],
    "content": "Active experience managing multi-cloud environments across Azure, AWS, and GCP since 2009. Design and implement cloud-native architectures that balance cost, performance, and compliance requirements."
  },
  {
    "slug": "m365-architecture",
    "category": "cto",
    "name": "Microsoft 365 Architecture",
    "icon": "microsoft.svg",
    "proficiency": "expert",
    "years": 16,
    "tags": [
      "m365",
      "dynamics365",
      "power-platform",
      "copilot"
    ],
    "content": "3rd level engineering and architecture for M365 tenants with MSP/Lighthouse/MS Partner status. Lead enterprise migrations including Dynamics 365 (Business Central, CRM/Sales, HR, Project) and Power Platform."
  },
  {
    "slug": "security-compliance",
    "category": "cto",
    "name": "Security & Compliance",
    "icon": "shield.svg",
    "proficiency": "expert",
    "years": 20,
    "tags": [
      "cybersecurity",
      "compliance",
      "finma",
      "governance"
    ],
    "content": "Cybersecurity best practices and regulatory compliance including FINMA-approved infrastructure operations. M365 Governance & Compliance certified with focus on data security and regulatory adherence."
  },
  {
    "slug": "llm-integration",
    "category": "developer",
    "name": "LLM Integration",
    "icon": "ai.svg",
    "proficiency": "advanced",
    "years": 3,
    "tags": [
      "llm",
      "ai",
      "automation",
      "copilot"
    ],
    "content": "Creating platforms and applications leveraging frontier model Machine Learning LLMs to enhance client interaction, transform CRM, automate form-filling, and accelerate IaC development. Experience with Llama, CoPilot, and custom tooling."
  },
  {
    "slug": "typescript",
    "category": "developer",
    "name": "TypeScript & React",
    "icon": "typescript.svg",
    "proficiency": "advanced",
    "years": 3,
    "tags": [
      "typescript",
      "react",
      "frontend",
      "web"
    ],
    "content": "Active software development in React and TypeScript (2024/2025). Built multiple production applications including X2BC, Agentisphere, and this Career Evolution Platform."
  },
  {
    "slug": "startup-ops",
    "category": "founder",
    "name": "Startup Operations",
    "icon": "startup.svg",
    "proficiency": "expert",
    "years": 21,
    "tags": [
      "startup",
      "operations",
      "leadership"
    ],
    "content": "Founded 4 companies across IT consulting, hosting, innovation, and adtech. Experience across all business functions: HR, Legal, Compliance, Marketing, Engineering, Product, Sales."
  },
  {
    "slug": "team-building",
    "category": "founder",
    "name": "Team Building & Talent",
    "icon": "team.svg",
    "proficiency": "expert",
    "years": 26,
    "tags": [
      "recruitment",
      "talent",
      "leadership",
      "culture"
    ],
    "content": "Managed recruitment, talent acquisition, and team building for cutting-edge tech initiatives. Focus on attracting top talent through culture and growth opportunities, not just salary gamification."
  },
  {
    "slug": "iac",
    "category": "infrastructure",
    "name": "Infrastructure as Code",
    "icon": "terraform.svg",
    "proficiency": "expert",
    "years": 10,
    "tags": [
      "terraform",
      "iac",
      "automation",
      "devops"
    ],
    "content": "LLM integration and automation for Infrastructure as Code (IaC) principles. Streamline processes through integrated automation and modern DevOps practices."
  },
  {
    "slug": "kubernetes",
    "category": "infrastructure",
    "name": "Kubernetes & Containers",
    "icon": "kubernetes.svg",
    "proficiency": "expert",
    "years": 8,
    "tags": [
      "kubernetes",
      "docker",
      "orchestration",
      "cloud-native"
    ],
    "content": "Container and orchestration technology expertise including Kubernetes and Docker deployments across cloud and hybrid environments."
  },
  {
    "slug": "linux",
    "category": "infrastructure",
    "name": "Linux Administration",
    "icon": "linux.svg",
    "proficiency": "expert",
    "years": 31,
    "tags": [
      "linux",
      "unix",
      "administration"
    ],
    "content": "Linux administration experience since 1995. Deep expertise in server management, security hardening, and system optimization."
  },
  {
    "slug": "mobile-platforms",
    "category": "product",
    "name": "Mobile Platforms",
    "icon": "mobile.svg",
    "proficiency": "advanced",
    "years": 8,
    "tags": [
      "mobile",
      "ios",
      "ble",
      "iot"
    ],
    "content": "Mobile Workforce Platform development integrating ad space reservation, planning, and lifecycle management with BLE sensors and mobile data analytics."
  },
  {
    "slug": "saas-development",
    "category": "product",
    "name": "SaaS Product Development",
    "icon": "saas.svg",
    "proficiency": "expert",
    "years": 15,
    "tags": [
      "saas",
      "product",
      "strategy"
    ],
    "content": "AI and SaaS development project leadership. Directed strategic roadmaps, product management, and go-to-market launches for multiple successful products."
  }
] as TechItem[]

export const techByCategory: Record<string, TechItem[]> = {
  "cto": [
    {
      "slug": "cloud-strategy",
      "category": "cto",
      "name": "Multi-Cloud Strategy",
      "icon": "cloud.svg",
      "proficiency": "expert",
      "years": 17,
      "tags": [
        "azure",
        "aws",
        "gcp",
        "architecture"
      ],
      "content": "Active experience managing multi-cloud environments across Azure, AWS, and GCP since 2009. Design and implement cloud-native architectures that balance cost, performance, and compliance requirements."
    },
    {
      "slug": "m365-architecture",
      "category": "cto",
      "name": "Microsoft 365 Architecture",
      "icon": "microsoft.svg",
      "proficiency": "expert",
      "years": 16,
      "tags": [
        "m365",
        "dynamics365",
        "power-platform",
        "copilot"
      ],
      "content": "3rd level engineering and architecture for M365 tenants with MSP/Lighthouse/MS Partner status. Lead enterprise migrations including Dynamics 365 (Business Central, CRM/Sales, HR, Project) and Power Platform."
    },
    {
      "slug": "security-compliance",
      "category": "cto",
      "name": "Security & Compliance",
      "icon": "shield.svg",
      "proficiency": "expert",
      "years": 20,
      "tags": [
        "cybersecurity",
        "compliance",
        "finma",
        "governance"
      ],
      "content": "Cybersecurity best practices and regulatory compliance including FINMA-approved infrastructure operations. M365 Governance & Compliance certified with focus on data security and regulatory adherence."
    }
  ],
  "developer": [
    {
      "slug": "llm-integration",
      "category": "developer",
      "name": "LLM Integration",
      "icon": "ai.svg",
      "proficiency": "advanced",
      "years": 3,
      "tags": [
        "llm",
        "ai",
        "automation",
        "copilot"
      ],
      "content": "Creating platforms and applications leveraging frontier model Machine Learning LLMs to enhance client interaction, transform CRM, automate form-filling, and accelerate IaC development. Experience with Llama, CoPilot, and custom tooling."
    },
    {
      "slug": "typescript",
      "category": "developer",
      "name": "TypeScript & React",
      "icon": "typescript.svg",
      "proficiency": "advanced",
      "years": 3,
      "tags": [
        "typescript",
        "react",
        "frontend",
        "web"
      ],
      "content": "Active software development in React and TypeScript (2024/2025). Built multiple production applications including X2BC, Agentisphere, and this Career Evolution Platform."
    }
  ],
  "founder": [
    {
      "slug": "startup-ops",
      "category": "founder",
      "name": "Startup Operations",
      "icon": "startup.svg",
      "proficiency": "expert",
      "years": 21,
      "tags": [
        "startup",
        "operations",
        "leadership"
      ],
      "content": "Founded 4 companies across IT consulting, hosting, innovation, and adtech. Experience across all business functions: HR, Legal, Compliance, Marketing, Engineering, Product, Sales."
    },
    {
      "slug": "team-building",
      "category": "founder",
      "name": "Team Building & Talent",
      "icon": "team.svg",
      "proficiency": "expert",
      "years": 26,
      "tags": [
        "recruitment",
        "talent",
        "leadership",
        "culture"
      ],
      "content": "Managed recruitment, talent acquisition, and team building for cutting-edge tech initiatives. Focus on attracting top talent through culture and growth opportunities, not just salary gamification."
    }
  ],
  "infrastructure": [
    {
      "slug": "iac",
      "category": "infrastructure",
      "name": "Infrastructure as Code",
      "icon": "terraform.svg",
      "proficiency": "expert",
      "years": 10,
      "tags": [
        "terraform",
        "iac",
        "automation",
        "devops"
      ],
      "content": "LLM integration and automation for Infrastructure as Code (IaC) principles. Streamline processes through integrated automation and modern DevOps practices."
    },
    {
      "slug": "kubernetes",
      "category": "infrastructure",
      "name": "Kubernetes & Containers",
      "icon": "kubernetes.svg",
      "proficiency": "expert",
      "years": 8,
      "tags": [
        "kubernetes",
        "docker",
        "orchestration",
        "cloud-native"
      ],
      "content": "Container and orchestration technology expertise including Kubernetes and Docker deployments across cloud and hybrid environments."
    },
    {
      "slug": "linux",
      "category": "infrastructure",
      "name": "Linux Administration",
      "icon": "linux.svg",
      "proficiency": "expert",
      "years": 31,
      "tags": [
        "linux",
        "unix",
        "administration"
      ],
      "content": "Linux administration experience since 1995. Deep expertise in server management, security hardening, and system optimization."
    }
  ],
  "product": [
    {
      "slug": "mobile-platforms",
      "category": "product",
      "name": "Mobile Platforms",
      "icon": "mobile.svg",
      "proficiency": "advanced",
      "years": 8,
      "tags": [
        "mobile",
        "ios",
        "ble",
        "iot"
      ],
      "content": "Mobile Workforce Platform development integrating ad space reservation, planning, and lifecycle management with BLE sensors and mobile data analytics."
    },
    {
      "slug": "saas-development",
      "category": "product",
      "name": "SaaS Product Development",
      "icon": "saas.svg",
      "proficiency": "expert",
      "years": 15,
      "tags": [
        "saas",
        "product",
        "strategy"
      ],
      "content": "AI and SaaS development project leadership. Directed strategic roadmaps, product management, and go-to-market launches for multiple successful products."
    }
  ]
} as Record<string, TechItem[]>

export const stats: StatsData[] = [
  {
    "slug": "companies",
    "title": "Companies Led or Founded",
    "type": "gantt",
    "startYear": 1994,
    "endYear": 2026,
    "entries": [
      {
        "name": "Autodesk (IT Manager)",
        "company": "Autodesk Inc.",
        "start": 1994,
        "end": 1996,
        "color": "#95a5a6",
        "type": "employment"
      },
      {
        "name": "UBS / SBC Warburg",
        "company": "UBS AG",
        "start": 1996,
        "end": 1999,
        "color": "#95a5a6",
        "type": "employment"
      },
      {
        "name": "Habitusnet (Founder)",
        "company": "Habitusnet Consulting AG",
        "start": 2000,
        "end": 2016,
        "color": "#3498db",
        "type": "founded"
      },
      {
        "name": "nHabitus (Founder)",
        "company": "nHabitus GmbH",
        "start": 2009,
        "end": 2020,
        "color": "#2ecc71",
        "type": "founded"
      },
      {
        "name": "idezo (Co-founder)",
        "company": "idezo GmbH",
        "start": 2014,
        "end": 2020,
        "color": "#9b59b6",
        "type": "co-founded"
      },
      {
        "name": "FLYERBEE (CEO)",
        "company": "FLYERBEE AG",
        "start": 2016,
        "end": 2021,
        "color": "#e74c3c",
        "type": "co-founded"
      },
      {
        "name": "Sygnum Bank",
        "company": "Sygnum Bank AG",
        "start": 2021,
        "end": 2022,
        "color": "#f39c12",
        "type": "employment"
      },
      {
        "name": "Habitusnet (Head)",
        "company": "Habitusnet Consulting AG",
        "start": 2022,
        "end": 2026,
        "color": "#3498db",
        "type": "employment"
      }
    ]
  },
  {
    "slug": "experience",
    "title": "Years of Experience",
    "type": "range-bars",
    "startYear": 1990,
    "endYear": 2026,
    "entries": [
      {
        "name": "IT Infrastructure",
        "start": 1990,
        "end": 2026,
        "color": "#3498db",
        "years": 36
      },
      {
        "name": "Software Development",
        "start": 1992,
        "end": 2026,
        "color": "#2ecc71",
        "years": 34
      },
      {
        "name": "Cloud Computing",
        "start": 2009,
        "end": 2026,
        "color": "#9b59b6",
        "years": 17
      },
      {
        "name": "Team Leadership",
        "start": 2000,
        "end": 2026,
        "color": "#e74c3c",
        "years": 26
      },
      {
        "name": "Microsoft 365",
        "start": 2010,
        "end": 2026,
        "color": "#f39c12",
        "years": 16
      },
      {
        "name": "Startup Founding",
        "start": 2000,
        "end": 2021,
        "color": "#1abc9c",
        "years": 21
      },
      {
        "name": "AI/ML Integration",
        "start": 2023,
        "end": 2026,
        "color": "#e67e22",
        "years": 3
      }
    ]
  },
  {
    "slug": "locations",
    "title": "Where I've Lived & Worked",
    "type": "timeline",
    "startYear": 1972,
    "endYear": 2026,
    "entries": [
      {
        "name": "Mexico City, MX",
        "start": 1972,
        "end": 1976,
        "color": "#e74c3c",
        "icon": "mx"
      },
      {
        "name": "Seattle, WA",
        "start": 1976,
        "end": 1995,
        "color": "#9b59b6",
        "icon": "us"
      },
      {
        "name": "Zurich, Switzerland",
        "start": 1995,
        "end": 2026,
        "color": "#2ecc71",
        "icon": "ch",
        "split": [
          {
            "name": "NYC",
            "percent": 50,
            "years": [
              1998,
              1999,
              2000,
              2001
            ],
            "color": "#3498db"
          }
        ]
      }
    ]
  },
  {
    "slug": "teams",
    "title": "Teams Led",
    "type": "metrics",
    "entries": [
      {
        "name": "Total Team Members Managed",
        "value": 75,
        "suffix": "+",
        "color": "#3498db"
      },
      {
        "name": "Companies Founded/Co-founded",
        "value": 4,
        "color": "#2ecc71"
      },
      {
        "name": "Years in Leadership",
        "value": 26,
        "suffix": " yrs",
        "color": "#e74c3c"
      },
      {
        "name": "Client Organizations Served",
        "value": 25,
        "suffix": "+",
        "color": "#9b59b6"
      },
      {
        "name": "Countries Worked In",
        "value": 5,
        "color": "#f39c12"
      }
    ]
  }
] as StatsData[]

export const education: EducationEntry[] = [
  {
    "slug": "uw-seattle",
    "category": "education",
    "institution": "University of Washington",
    "location": "Seattle, WA",
    "degree": "Studies in Physics, Business, IT",
    "start": 1990,
    "end": 1995,
    "icon": "uw.svg",
    "tags": [
      "physics",
      "business",
      "information-technology"
    ],
    "content": "Interdisciplinary studies combining Physics, Business, and Information Technology at the University of Washington. This diverse academic foundation provided the analytical rigor and business acumen that has shaped my approach to technology leadership."
  }
] as EducationEntry[]

export const certifications: CertificationEntry[] = [
  {
    "slug": "azure-architecture",
    "category": "certifications",
    "name": "Azure Architecture & Cybersecurity",
    "issuer": "Microsoft",
    "icon": "azure.svg",
    "tags": [
      "azure",
      "architecture",
      "cybersecurity",
      "iam",
      "networking"
    ],
    "content": "Comprehensive certification covering Azure architecture, networking, hardware integration, identity and access management, and leadership development."
  },
  {
    "slug": "itil",
    "category": "certifications",
    "name": "ITIL Foundation",
    "issuer": "AXELOS",
    "icon": "itil.svg",
    "tags": [
      "itil",
      "service-management",
      "operations"
    ],
    "content": "IT service management framework certification, applied consistently since 2000 across enterprise environments."
  },
  {
    "slug": "m365-governance",
    "category": "certifications",
    "name": "Microsoft 365 Governance & Compliance",
    "issuer": "Microsoft",
    "icon": "microsoft.svg",
    "tags": [
      "m365",
      "governance",
      "compliance",
      "security"
    ],
    "content": "Certification in ensuring data security and regulatory adherence within the Microsoft 365 ecosystem."
  },
  {
    "slug": "six-sigma",
    "category": "certifications",
    "name": "Six Sigma Foundations",
    "issuer": "Professional Certification",
    "icon": "six-sigma.svg",
    "tags": [
      "process-improvement",
      "methodology",
      "operations"
    ],
    "content": "Process improvement methodology certification enabling data-driven decision making and operational excellence."
  }
] as CertificationEntry[]

export const products: ProductEntry[] = [] as ProductEntry[]

export const metas: Record<string, CategoryMeta> = {
  "career": {
    "title": "Career",
    "description": "Professional experience and work history",
    "icon": "briefcase",
    "order": [
      "habitusnet-2022",
      "sygnum-2021",
      "flyerbee-2016",
      "idezo-2014",
      "nhabitus-2009",
      "habitusnet-2000",
      "ubs-1996",
      "autodesk-1994"
    ]
  },
  "tech": {
    "title": "Tech Stack",
    "description": "Technologies and expertise organized by role",
    "icon": "layers",
    "categories": [
      {
        "id": "cto",
        "name": "CTO / Architecture",
        "icon": "crown",
        "description": "Strategic technology leadership and system design"
      },
      {
        "id": "infrastructure",
        "name": "Infrastructure",
        "icon": "server",
        "description": "Cloud, DevOps, and platform engineering"
      },
      {
        "id": "developer",
        "name": "Developer",
        "icon": "code",
        "description": "Hands-on coding and software development"
      },
      {
        "id": "product",
        "name": "Product Lead",
        "icon": "lightbulb",
        "description": "Product strategy and management"
      },
      {
        "id": "founder",
        "name": "Founder / COO",
        "icon": "rocket",
        "description": "Business operations and startup leadership"
      }
    ]
  },
  "education": {
    "title": "Education",
    "description": "Academic background",
    "icon": "graduation-cap"
  },
  "certifications": {
    "title": "Certifications",
    "description": "Professional certifications and credentials",
    "icon": "certificate"
  }
} as Record<string, CategoryMeta>

export const manifest: ContentManifest = {
  career,
  tech,
  stats,
  education,
  certifications,
  products,
  skills: [],
  metas,
}

export default manifest
